<template>
  <div class="MissionForm-container">
    <mission-form
      :missionId="missionId"
      :mission="mission"
      :pathId="pathId"
      @submit-success="$router.push(`/pathManagement/${pathId}`)"
      @go-to-path="$router.push(`/pathManagement/${pathId}`)"
      @uploading-media="uploadingMedia"
    />
    <!-- media loading dialog-->
    <load-dialog :isUploading="isUploading" :percentProgress="percentProgress">
    </load-dialog>
  </div>
</template>

<script>
import MissionForm from '../components/MissionForm';
import LoadDialog from '../components/LoadDialog.vue';

export default {
  name: 'EditMission',
  components: {
    MissionForm,
    LoadDialog,
  },
  data() {
    return {
      missionId: '',
      pathId: '',
      langEdition: '',
      isUploading: false,
      percentProgress: 0,
    };
  },
  computed: {
    mission() {
      return this.$store.getters['missions/getMissionById'](this.missionId);
    },
  },
  beforeMount() {
    this.missionId = this.$route.params.missionId;
    this.pathId = this.$route.params.pathId;
  },

  methods: {
    uploadingMedia(isUploading, percentProgress) {
      this.isUploading = isUploading;
      this.percentProgress = percentProgress;
    },
  },
};
</script>

<style lang="sass" scoped>
.cancelBtn
  margin-left: 1em
.MissionForm-container
  padding-left: 1em
</style>
